import html2pdf from 'html2pdf.js';

export function exportPdf(element: HTMLElement, filename: string) {
  return html2pdf()
    .set({
      margin: 0,
      filename,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        backgroundColor: 'white',
        // Render the PDF in LIGHT mode regardless of the active theme: strip
        // the `.dark` class from the cloned document so all token-driven
        // colors resolve to their light values for the capture.
        onclone: (doc: Document) =>
          doc.documentElement.classList.remove('dark'),
      },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    })
    .from(element)
    .save();
}
